import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/yeni.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="ESR Group" className="navbar-logo-img" />
        </Link>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Ana Sayfa
          </Link>
          <Link
            to="/hakkımızda"
            className={`navbar-link ${isActive('/hakkımızda') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Hakkımızda
          </Link>
          <Link
            to="/hizmetler"
            className={`navbar-link ${location.pathname.startsWith('/hizmetler') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Hizmetler
          </Link>
          <Link
            to="/iletisim"
            className={`navbar-link ${isActive('/iletisim') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            İletişim
          </Link>
        </div>

        <button
          className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;

